export default __webpack_public_path__ + "static/media/pdonuts-image.99bcce25.png";